import { getSubjectList } from "../services/taxonomyService";

/**
 * Get Subject list
 * @param selectedExamId
 * @returns {Function}
 */
export const getSubjectsList = (selectedExamId) => dispatch => {
    getSubjectList(selectedExamId).then((response) => {
        // handle success
        dispatch({
            type: 'GET_SUBJECT_LIST_SUCCESS',
            payload: response
        });
    })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'GET_SUBJECT_LIST_ERROR',
                payload: []
            });
        });

};
